import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Grid, Header, Icon, Image, Menu } from 'semantic-ui-react';
import * as Core from '../../core';
import { ApplicationState, strings } from '../..';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

const connector = connect(
    (state: ApplicationState) => ({
        utente: state.core.auth.user!,
        anagrafiche: state.core.anagrafiche.lista
    }),
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type SelezionaAnagraficaProps = PropsFromRedux

class SelezionaAnagrafica extends React.Component<SelezionaAnagraficaProps> {

    componentDidMount() {
        this.props.loadAnagrafiche();
    }

    render() {
        const tenantImageSmall = this.props.utente?.profile?.picture ?? '';
        const tenantName = this.props.utente?.profile?.tenantName ?? 'CATA';

        return (
            <Grid centered stackable>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="tablet">
                        <Grid.Row>
                            <Image src={tenantImageSmall} alt={tenantName} size='small' />
                        </Grid.Row>
                    </Media>
                </MediaContextProvider>
                <Grid.Row>
                    <Header as='h2'>{strings.core.selezionaDitta}</Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign='center' computer='8' tablet='12' mobile='16'>
                        <Menu vertical fluid>
                            {this.props.anagrafiche.map(this.renderAzienda)}
                        </Menu>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    renderAzienda = (anagrafica: Core.Anagrafica) => {
        return (
            <Menu.Item key={anagrafica.idAnagrafica} onClick={() => this.props.anagraficaSelezionata(anagrafica)}>
                <Grid>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column width='2'><Icon size='big' name='building outline' /></Grid.Column>
                        <Grid.Column width='12'>{anagrafica.ragioneSociale}</Grid.Column>
                        <Grid.Column width='2'><Icon name='arrow right' /></Grid.Column>
                    </Grid.Row>
                </Grid>
            </Menu.Item>
        );
    }
}

export default connector(SelezionaAnagrafica);